import React, { useState } from "react";
import { observer } from "mobx-react";
import copy from 'copy-to-clipboard';

const CopyValue = observer((props) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () =>{

        copy(props.text);

        setCopied(true);

        setTimeout(()=>{
            setCopied(false);
        }, 1000)
    }
    return (
        <>
        {!copied ? (<i className="ti ti-clipboard text-muted cursor-pointer" onClick={handleCopy} title="Copy Value"></i>) : (<i className="ti ti-check text-muted"></i>)}
        </>
    );
  });
  
  export default CopyValue;
  